// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RichTextWithAssetContainer_wrapper__sJq1R"};